// https://reactjs.org/blog/2015/12/16/ismounted-antipattern.html
export class CanceledError extends Error {
}
export const createCancelablePromise = (promise) => {
    let hasBeenCancelled = false;
    const wrappedPromise = new Promise((resolve, reject) => {
        promise
            .then(value => {
            hasBeenCancelled ? reject(new CanceledError()) : resolve(value);
        })
            .catch(error => {
            hasBeenCancelled ? reject(new CanceledError()) : reject(error);
        });
    });
    return {
        promise: wrappedPromise,
        cancel: () => {
            hasBeenCancelled = true;
        }
    };
};
//# sourceMappingURL=cancelable-promises.js.map